import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Vkiddm = function Vkiddm(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.56c0-4.978 0-7.467 1.546-9.014C3.093 0 5.582 0 10.56 0h.88c4.978 0 7.467 0 9.013 1.546C22 3.093 22 5.582 22 10.56v.88c0 4.978 0 7.467-1.547 9.013C18.907 22 16.418 22 11.44 22h-.88c-4.978 0-7.467 0-9.014-1.547C0 18.907 0 16.418 0 11.44v-.88zm3.667-3.838c.117 5.723 3.123 9.167 8.078 9.167h.287v-3.274c1.805.183 3.15 1.532 3.7 3.274h2.601c-.705-2.606-2.535-4.046-3.673-4.597 1.137-.68 2.745-2.33 3.124-4.57h-2.367c-.496 1.821-1.974 3.471-3.386 3.628V6.722H9.627v6.352c-1.464-.367-3.373-2.148-3.451-6.352h-2.51z",
    fill: "#fff"
  }));
};
export default Vkiddm;